import { inject, Pipe, PipeTransform } from '@angular/core';
import { AuthService } from '../../core/auth.service';
import { RoleName } from '../../../../common/interfaces/MainMenu';

@Pipe({
  name: 'userAuth'
})
export class UserAuthPipe implements PipeTransform {
  private authService = inject(AuthService);

  transform(value: RoleName): boolean {
    return this.authService.hasRole(value);
  }
}
